export function remoteJS(realtorName) {
  return new Promise(function (resolve, reject) {
    const url = `https://storage.googleapis.com/realtor.homapp.com/${realtorName}/configs.js`
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
    script.onerror = reject;
    script.onload = () => {
      resolve();
    }
  })
}